const ComparisonGuide = function() {
    function ComparisonGuide() {
        this.selector = {
            firstmain: document.getElementById('first-main-selection'),
            secondmain: document.getElementById('second-main-selection'),
            thirdmain: document.getElementById('third-main-selection'),
            firstcomparisonboxes: document.querySelectorAll('.first-main .comparison_box'),
            secondcomparisonboxes: document.querySelectorAll('.second-main .comparison_box'),
            thirdcomparisonboxes: document.querySelectorAll('.third-main .comparison_box'),
            vimeobox: document.getElementById('vimeo-modal-box'),
            vimeolink: document.querySelectorAll('.comparison_box .video_icon .udd-video'),
            vimeoboxclose: document.getElementById('vimeo-modal-box-close'),
            mp4player: document.getElementById('mp4-player')
        }
        this.state = {
            videoId: '816881886',
            player: null
        }
        this.load();
    }
    ComparisonGuide.prototype.load = function() {
        var _ = this;
            if(_.selector.firstmain.options.length > 0) {
                Array.from(_.selector.firstmain.options).forEach(option => {
                    if(option.value.includes('bamboo')) {
                        _.selector.firstmain.selectedIndex = option.index;
                    }
                })
                _.selector.firstmain.addEventListener('change', event => {
                        event.target.closest('.comparison_section').classList.add(event.target.options[event.target.selectedIndex].value);
                        if(_.selector.firstcomparisonboxes.length > 0) {
                            _.selector.firstcomparisonboxes.forEach(box => {
                                if(box.dataset.productName === event.target.options[event.target.selectedIndex].value) {
                                    box.classList.add('is-active');
                                } else {
                                    box.classList.remove('is-active');
                                }
                            })
                        }
                })  
            }
            if(_.selector.secondmain.options.length > 0) {
                Array.from(_.selector.secondmain.options).forEach(option => {
                    if(option.value.includes('white-melamine')) {
                        _.selector.secondmain.selectedIndex = option.index;
                    }
                })
                _.selector.secondmain.addEventListener('change', event => {
                        event.target.closest('.comparison_section').classList.add(event.target.options[event.target.selectedIndex].value);
                        if(_.selector.secondcomparisonboxes.length > 0) {
                            _.selector.secondcomparisonboxes.forEach(box => {
                                if(box.dataset.productName === event.target.options[event.target.selectedIndex].value) {
                                    box.classList.add('is-active');
                                } else {
                                    box.classList.remove('is-active');
                                }
                            })
                        }
                })  
            }
            if(_.selector.thirdmain.options.length > 0) {
                Array.from(_.selector.thirdmain.options).forEach(option => {
                    if(option.value.includes('Select Desktop')) {
                        _.selector.thirdmain.selectedIndex = option.index;
                    }
                })
                _.selector.thirdmain.addEventListener('change', event => {
                        event.target.closest('.comparison_section').classList.add(event.target.options[event.target.selectedIndex].value);
                        if(_.selector.thirdcomparisonboxes.length > 0) {
                            _.selector.thirdcomparisonboxes.forEach(box => {
                                if(box.dataset.productName === event.target.options[event.target.selectedIndex].value) {
                                    box.classList.add('is-active');
                                } else {
                                    box.classList.remove('is-active');
                                }
                            })
                        }
                })
            }    
            if(_.selector.vimeolink.length > 0) {
                _.selector.vimeolink.forEach(vimeo => {
                    vimeo.addEventListener('click', event => {                  
                        const videoSrc = event.target.closest('a').dataset.videoSrc;
                        if(videoSrc.includes('.mp4')) {
                            _.mp4play(videoSrc);
                        } else if(videoSrc !== '') {
                            _.vimeoplay(videoSrc);
                        } else {
                            return true;
                        }                      
                    })
                })
            }
            if(_.selector.vimeoboxclose) {
                _.selector.vimeoboxclose.addEventListener('click', () => {
                    if(_.state.player) {
                        _.state.player.destroy();
                    }
                    _.selector.mp4player.innerHTML = '';
                    _.selector.vimeobox.classList.remove('active');
                })               
            }
    }
    ComparisonGuide.prototype.vimeoplay = function(src) {
        var _ = this;
        _.selector.vimeobox.classList.add('active');
        _.state.player = new Vimeo.Player('vimeo-player', {
            url: 'https://vimeo.com/' + src,
            autoplay: true,
            loop: true,
            muted: true,
            controls: false
        });
        _.state.player.on('play', function() {});
    }
    ComparisonGuide.prototype.mp4play = function(src) {
        var _ = this;
        _.selector.vimeobox.classList.add('active');
        var mp4video = document.createElement('video');
        mp4video.src = src; 
        mp4video.controls = false;
        mp4video.autoplay = true;
        mp4video.addEventListener('loadedmetadata', function() {
            var aspectRatio = mp4video.videoWidth / mp4video.videoHeight;
            var width = mp4video.clientWidth;
            var height = width / aspectRatio;
            mp4video.style.width = width + 'px';
            mp4video.style.height = height + 'px';
        }) 
        _.selector.mp4player.appendChild(mp4video);
    }
    ComparisonGuide = new ComparisonGuide;
}
ComparisonGuide();